import React from 'react';
import InsightsHeader from 'components/insights/InsightsHeader';
import InsightsTable from 'components/insights/InsightsTable';
import clsx from 'clsx';
import { createStyles } from '../../globalStyles';

const InsightsPage = (): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={clsx(classes.pageWrapper, classes.widePageWrapper)}>
      <InsightsHeader />
      <InsightsTable />
    </div>
  );
};

export default InsightsPage;
